import { AlertTriangle } from 'lucide-react'
import { useCallback, useState } from 'react'

import { Modal } from '@/components/lemmala-design-system/modal/modal'
import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'

export function useErrorModal() {
  const [isOpen, setIsOpen] = useState(false)
  const [error, setError] = useState<string>('')

  const closeModal = async () => setIsOpen(false)
  const showModal = useCallback((errorText: string) => {
    setError(errorText)
    setIsOpen(true)
  }, [])

  const renderModal = () => (
    <Modal
      open={isOpen}
      onOk={closeModal}
      onCancel={closeModal}
      title='Error'
      primaryButtonText='OK'
      showCancelButton={false}
    >
      <TextWithIcon icon={<AlertTriangle size={20} />} text={error} className='text-wrap' />
    </Modal>
  )

  return { showModal, renderModal }
}
